import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'semantic-ui-react';

const BugReportForm = ({ handleReportForm }) => {
  return (
    <Modal basic size="small" id="bug-report-modal" open={handleReportForm} onClose={handleReportForm}>
      <Modal.Content>
        <iframe
          style={{
            width: '100%',
            height: '80vh',
            border: 'none',
          }}
          src="https://www.formpl.us/form/5071410917670912"
        />
      </Modal.Content>
    </Modal>
  );
};

export default BugReportForm;

BugReportForm.propTypes = {
  handleReportForm: PropTypes.func.isRequired,
};
